export default __webpack_public_path__ + "static/media/hero-the-company-mobile.55f52303.jpg";